import { VehicleRowGroup } from 'src/pages/ConvenienceDispatches/adapter';

/** 車両リストの 1 グループ。key は並べ替えの識別子、truckId は保存する並び順の単位 */
export type VehicleSortableGroup = { key: string; truckId: number | null };

/** vehicle.id は `truck-{truckId}` 形式の string。dnd-kit と API には number を渡す */
function truckIdOf(vehicleId: string): number | null {
  const n = Number(vehicleId.replace('truck-', ''));
  return Number.isFinite(n) ? n : null;
}

/**
 * グループの識別子。
 *
 * グループは勤務 (delivery) 単位なので、1 台に 2 つの勤務が乗ると同じ車両のグループが
 * 2 つ並ぶ。車両 (vehicle.id) をそのまま使うと React key と dnd-kit の id が重複し、
 * 「Encountered two children with the same key」で行が重複・欠落しうる。
 */
export function vehicleRowGroupKey(
  group: Pick<VehicleRowGroup, 'shiftTruckId' | 'vehicle'>,
): string {
  return group.shiftTruckId != null ? `shift-${group.shiftTruckId}` : group.vehicle.id;
}

/** グループごとの並べ替えキー。識別子の作り方は vehicleRowGroupKey に寄せる */
export function buildVehicleSortableGroups(
  rowGroups: readonly VehicleRowGroup[],
): VehicleSortableGroup[] {
  return rowGroups.map((g) => ({
    key: vehicleRowGroupKey(g),
    truckId: truckIdOf(g.vehicle.id),
  }));
}

/**
 * 並べ替え後のキー列から、保存する車両の並び順を作る。
 * 並び順の設定は車両単位 (truck_display_order) なので、同じ車両は最初の位置に 1 度だけ。
 */
export function truckOrderFromKeys(
  groups: readonly VehicleSortableGroup[],
  orderedKeys: readonly string[],
): number[] {
  const truckIdByKey = new Map(groups.map((g) => [g.key, g.truckId]));
  const ids: number[] = [];
  for (const key of orderedKeys) {
    const truckId = truckIdByKey.get(key);
    if (truckId == null || ids.includes(truckId)) continue;
    ids.push(truckId);
  }
  return ids;
}
